import React from 'react'
import { useForm } from 'react-hook-form'
import Form from '../../components/Form'
import FormItem from '../../components/Form/FormItem'
import InputText from '../../components/Inputs/InputText'
import { Components } from 'safe'
import Select from '../../components/Inputs/Select'
import Button from '../../components/General/Button'

const PayrollForm: React.FC<IPayrollForm> = ({ onSubmit, iSavingPayroll, onCancel, selectedPayroll }) => {
  const form = useForm<ICreatePayroll>({
    defaultValues: {
      ...selectedPayroll
    }
  })

  const salaryFrecuencyOptions : Components.SelectOption[] = [
    {
      value: 'MONTHLY',
      text: 'Mensual',
    },
    {
      value: 'WEEKLY',
      text: 'Semanal',
    },
    {
      value: 'BIWEEKLY',
      text: 'Quincenal',
    },
  ]

  const onGetDefaultSalaryFrecuency = () => {
    return salaryFrecuencyOptions?.find(v => v?.value === selectedPayroll?.salaryFreq)
  }

  return (
    <Form classes="gap-x-5" form={form} onSubmit={onSubmit}>
      <h2 className="col-span-12 mb-2 text-primary-900 font-bold">
        {selectedPayroll ? 'Editar nómina' : 'Añadir nómina'}
      </h2>

      <FormItem
          name="name"
          classes="xl:col-span-12 col-span-12"
          rules={{ required: 'Es necesario un nombre' }}
        >
          <InputText label="Nombre" />
        </FormItem>


        <FormItem
          name="salaryFreq"
          classes="xl:col-span-12 col-span-12"
          rules={{ required: 'Es necesario un nombre' }}
          defaultValue={
            selectedPayroll ? onGetDefaultSalaryFrecuency() : salaryFrecuencyOptions[0]
          }
        >
          <Select label="Frecuencia" options={salaryFrecuencyOptions} disabled={selectedPayroll !== null} />
        </FormItem>

        <div className="col-span-12 h-full flex flex-row mt-5">
          <div className="w-1/2 mr-5 pl-1">
            <Button
              onClick={() => {
                onCancel()
              }}
              type="outline"
              classes="w-full"
            >
              Cancelar
            </Button>
          </div>
          <div className="w-1/2 pr-1">
            <Button
              type="primary"
              loading={iSavingPayroll}
              classes="w-full"
              htmlType="submit"
            >
              {selectedPayroll ? 'Guardar cambios' : 'Añadir'}
            </Button>
          </div>
        </div>
    </Form>
  )
}

interface IPayrollForm {
  onSubmit: (values: ICreatePayroll) => void
  iSavingPayroll: boolean
  onCancel: () => void
  selectedPayroll: ICreatePayroll | null
}

export interface ICreatePayroll {
  name: string;
  salaryFreq: "WEEKLY" | "BIWEEKLY" | "MONTHLY"
}

export default PayrollForm
